import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { AlignmentControl, BlockControls, RichText, useBlockProps } from '@wordpress/block-editor';
import { BlockQuotation } from '@wordpress/components';
import { createBlock, getDefaultBlockName } from '@wordpress/blocks';
import { Platform } from '@wordpress/element';
const isWebPlatform = Platform.OS === 'web';
export default function QuoteEdit(_ref) {
  let {
    attributes,
    setAttributes,
    isSelected,
    mergeBlocks,
    onReplace,
    className,
    insertBlocksAfter,
    style
  } = _ref;
  const {
    align,
    value,
    citation
  } = attributes;
  const blockProps = useBlockProps({
    className: classnames(className, {
      [`has-text-align-${align}`]: align
    }),
    style
  });
  return createElement(Fragment, null, createElement(BlockControls, {
    group: "block"
  }, createElement(AlignmentControl, {
    value: align,
    onChange: nextAlign => {
      setAttributes({
        align: nextAlign
      });
    }
  })), createElement(BlockQuotation, blockProps, createElement(RichText, {
    identifier: "value",
    multiline: true,
    value: value,
    onChange: nextValue => setAttributes({
      value: nextValue
    }),
    onMerge: mergeBlocks,
    onRemove: forward => {
      const hasEmptyCitation = !citation || citation.length === 0;

      if (!forward && hasEmptyCitation) {
        onReplace([]);
      }
    },
    "aria-label": __('Quote text'),
    placeholder: // translators: placeholder text used for the quote
    __('Add quote'),
    onReplace: onReplace,
    onSplit: piece => createBlock('core/quote', { ...attributes,
      value: piece
    }),
    __unstableOnSplitMiddle: () => createBlock('core/paragraph'),
    textAlign: align,
    __unstableEmbedURLOnPaste: true
  }), (!RichText.isEmpty(citation) || isSelected) && createElement(RichText, {
    identifier: "citation",
    tagName: isWebPlatform ? 'cite' : undefined,
    style: {
      display: 'block'
    },
    value: citation,
    onChange: nextCitation => setAttributes({
      citation: nextCitation
    }),
    __unstableMobileNoFocusOnMount: true,
    "aria-label": __('Quote citation text'),
    placeholder: // translators: placeholder text used for the citation
    __('Add citation'),
    className: "wp-block-quote__citation",
    textAlign: align,
    __unstableOnSplitAtEnd: () => insertBlocksAfter(createBlock(getDefaultBlockName()))
  })));
}
//# sourceMappingURL=edit.js.map